import { createContext, useContext } from "react";
import type { SupplierSession } from "@shared-core/data/supplier-portal-adapter";

export interface SupplierSessionState {
  session: SupplierSession;
  /** Read the session again (its counts change after an action). */
  refresh: () => void;
}

export const SupplierSessionContext =
  createContext<SupplierSessionState | null>(null);

/** The signed-in session, or null on a page opened by link. */
export function useSupplierSession(): SupplierSessionState | null {
  return useContext(SupplierSessionContext);
}
